import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import Guest from './Guest';

class GuestDetails extends Component {

	render() {
		const { noOfGuests } = this.props;

		return (
			<div>
				{Array.from({ length: noOfGuests }, (_, i) => <Guest key={i} index={i} />)}
			</div>
		);
	}
}

export default compose(
	connect(state => ({
		noOfGuests: state.app.totalNoOfGuests,
	})),
)(GuestDetails);



// WEBPACK FOOTER //
// ./src/components/GuestDetails/index.jsx